import { render, staticRenderFns } from "./integralOrderDetails.vue?vue&type=template&id=5feb84f2&scoped=true"
import script from "./integralOrderDetails.vue?vue&type=script&lang=js"
export * from "./integralOrderDetails.vue?vue&type=script&lang=js"
import style0 from "./integralOrderDetails.vue?vue&type=style&index=0&id=5feb84f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5feb84f2",
  null
  
)

export default component.exports